// Personel Hareketleri (personel cari defteri) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.actions';

export const personnelActionsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Personel hareketleri nasıl izlenir?'),
  intro: t(`${G}.intro`, 'Bu sayfa personelin cari defteridir: borç, alacak, ödeme, tahsilat, avans ve maaş/prim hakedişleri burada tutulur. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Personel adı ve şube'),
    stats: t(`${G}.regions.stats`, 'Güncel Bakiye'),
    filters: t(`${G}.regions.filters`, 'Tarih ve işlem türü filtresi'),
    toolbar: t(`${G}.regions.toolbar`, 'Filtre ve ⋮ işlemler menüsü'),
    table: t(`${G}.regions.table`, 'Hareket tablosu'),
    pagination: t(`${G}.regions.pagination`, 'Genel Toplam ve sayfalar'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Üstte personelin adı ve bağlı olduğu şube yazar. Personelle yaptığınız tüm para ve hakediş kayıtları tarih sırasıyla aşağıdaki tabloda listelenir. "Geri" düğmesi bir önceki sayfaya döner.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Güncel Bakiyeyi okuyun'),
      text: t(`${G}.s2.text`, 'Bakiye şirketin gözünden ve her para birimi için ayrı hesaplanır. "Şirket Alacağı (Personel Borcu)" ve "Ödeme" bakiyeyi artırır; "Şirket Borcu (Personel Alacağı)" ve "Tahsilat" bakiyeyi azaltır. Tahakkuklar (maaş/prim hakedişleri) dahil tüm hareketler sayılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yeşil (artı) bakiye: "Şirketin alacağı var" — personel şirkete borçlu.'),
        t(`${G}.s2.tip2`, 'Kırmızı (eksi) bakiye: "Şirketin borcu var" — şirket personele borçlu (ör. ödenmemiş maaş).'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. ⋮ menüsünden işlem ekleyin'),
      text: t(`${G}.s3.text`, 'Sağ üstteki ⋮ düğmesi tüm işlemleri açar: "Borç Ekle" ve "Alacak Ekle" (varsayılan yöntem Tahakkuk), "Ödeme Ekle" ve "Tahsilat Ekle" (varsayılan yöntem Nakit), "Maaş Oluştur" ve "Prim Oluştur" (hakediş yazar), "Maaş Ödemesi Yap", "Prim Ödemesi Yap" (hakedişi öder) ve "Avans Ver". Her pencerenin kendi (i) rehberi vardır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Nakit veya Banka seçilen işlemlerde kasa/banka hareketi de oluşur: Borç ve Ödeme seçilen kasadan/bankadan para çıkarır, Alacak ve Tahsilat para girişi yapar. Tahakkukta para hareketi olmaz.'),
        t(`${G}.s3.tip2`, '"Avans Ver" ödeme penceresini "… için avans" açıklamasıyla açar ve ödemeyi avans olarak işaretler; sonraki "Maaş Oluştur"da bu avansın maaştan düşülmesi önerilir.'),
        t(`${G}.s3.tip3`, 'Şube yöneticisi yalnız kendi şubesinin kasa ve banka hesaplarını görür; proje alanı görünmez.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s4.title`, '4. Hareketleri süzün'),
      text: t(`${G}.s4.text`, 'Filtre düğmesi Başlangıç Tarihi, Bitiş Tarihi ve İşlem Türü alanlarını açar. Seçip "Filtrele"ye basın; "Filtre aktif: … kayıt görüntüleniyor" yazısı kaç kaydın gösterildiğini söyler. "Filtreyi Temizle" tüm listeye döner.'),
      tips: [
        t(`${G}.s4.tip1`, 'Filtre yalnız tabloyu, Genel Toplamı ve Excel dosyasını süzer; Güncel Bakiye değişmez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Tabloyu ve hareket detayını okuyun'),
      text: t(`${G}.s5.text`, 'Her satırda İşlem Tarihi, İşlem Türü, Ödeme Tipi, Açıklama, Şirket Alacağı, Şirket Borcu, Bakiye, Banka/Kasa ve İşlemi Yapan görünür. "Bakiye" o hareketten sonraki yürüyen bakiyedir. Satıra tıklayınca "Hareket Detayı" açılır: önceki ve sonraki bakiye ile işlemin yönü burada yazar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Banka/Kasa sütunu paranın çıktığı/girdiği kasa ya da bankayı gösterir; hakedişlerde "Maaş", "Prim" veya "Tahakkuk" yazar. Detayda "Tahakkuk (para hareketi yok)" etiketi görünür.'),
        t(`${G}.s5.tip2`, 'Tabloda en yeni 500 hareket listelenir; Güncel Bakiye ise tüm hareketlerden hesaplanır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Yanlış hareketi silin'),
      text: t(`${G}.s6.text`, 'Satırın sonundaki çöp kutusu ("Hareketi Sil") "Hareket Silme Onayı" penceresini açar. Harekete bağlı bir kasa/banka hareketi varsa o da silinir ve kasa/banka bakiyesi geri alınır. Bu işlem geri alınamaz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Tahakkuk kayıtlarında para hareketi yoktur; yalnız personel defterindeki kayıt silinir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Toplamlar, sayfalar ve Excel'),
      text: t(`${G}.s7.text`, 'Tablonun altındaki "Genel Toplam" gösterilen (filtrelenmiş) hareketlerin Şirket Alacağı ve Şirket Borcu toplamlarını verir. Sayfa başına 10, 25, 50 veya 100 satır seçebilirsiniz. ⋮ menüsündeki "Excel İndir" gösterilen hareketleri GENEL TOPLAM satırıyla birlikte Excel dosyasına aktarır.'),
    },
  ],
});
